import { ref, readonly } from 'vue'

const pendingKeys = ref(new Set(['app-init']))
export const isInitialLoadComplete = ref(false)

export function holdInitialLoad (key) {
  if (isInitialLoadComplete.value) return
  pendingKeys.value = new Set([...pendingKeys.value, key])
}

export function releaseInitialLoad (key) {
  if (isInitialLoadComplete.value) return
  const next = new Set(pendingKeys.value)
  next.delete(key)
  pendingKeys.value = next
  if (next.size === 0) {
    isInitialLoadComplete.value = true
  }
}

export function forceCompleteInitialLoad () {
  pendingKeys.value = new Set()
  isInitialLoadComplete.value = true
}

export function useInitialLoad () {
  return {
    isInitialLoadComplete: readonly(isInitialLoadComplete),
    holdInitialLoad,
    releaseInitialLoad,
    forceCompleteInitialLoad
  }
}
